<template>
  <div
    v-if="visible"
    id="banner-newsletter-signup"
    class="
      $motion/transition:curve:ease-out
      $motion/transition:duration:150ms
      layout/flex
      layout/justify:center
      layout/transform
      layout/wrapper
      motion/transition
      layout/opacity
      layout/z-index:-1
    "
    :style="{
      '--layout--transform': transform,
      '--layout--opacity': opacity,
    }"
    >
    <div
      class="
        @768/layout/padding:page:0.5
        @600/layout/width:66%
        $color/background:white
        $layout/page:fixed
        color/background
        layout/border:3pt
        layout/margin:bottom:page:0.5
        layout/padding:page
        layout/width:100%
      "
      >
      <div
        class="
          layout/flex
          layout/relative
        "
        >
        <collapsible-block
          aria-label="newsletter signup"
          block-name="newsletter-signup"
          title="Get art and ideas in your&nbsp;inbox"
          class="layout/width:100%"
          button-class="icon-link__text--prominent--body"
          >
          <Signup
            :source="newsletterConfig.source"
            :flags="newsletterConfig.flags"
            :placeholder="newsletterString"
            :optin="newsletterConfig.optin"
          />
        </collapsible-block>
        <div
          class="
            layout/absolute
            layout/right:0%
          "
          >
          <button
            class="
              link/focus
            "
            @click.prevent="dismiss"
            >
            <icon
              icon-name="icon__x--24--stroke.svg"
              class-name="
                $typography/size:medium
                typography/icon
              "
            />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Signup from "./../subscription-signup";
  import Icon from "Components/icons/icon";
  import CollapsibleBlock from 'Components/shared/blocks/collapsible-block.vue';

  export default {
    components: {
      Signup,
      Icon,
      CollapsibleBlock,
    },
    props: {
      newsletterConfig: {type: Object, required: true},
    },
    data: function() {
      return {
        visible: true,
        hidden: true,
        width: window.innerWidth,
      };
    },
    computed: {
      transform: function() {
        return this.hidden ? 'translateY(100%)' : 'translateY(0%)';
      },
      opacity: function() {
        return this.hidden ? '0' : '100';
      },
      newsletterString: function() {
        if (this.width <= 360) {
          return 'Newsletter sign up';
        }
        return 'Sign up for our newsletters';
      }
    },
    mounted: function() {
      setTimeout(() => {
        this.hidden = false;
      }, 2000);
      window.addEventListener('resize', this.onResize);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.onResize);
    },
    methods: {
      dismiss: function() {
        this.visible = false;
        this.hidden = true;

        this.$emit('dismiss');
      },
      onResize: function() {
        this.width = window.innerWidth;
      },
    }
  };
</script>
